// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tier-star {
  display: inline-block;
  flex: 0 0 auto;
  line-height: 0;
  --tier-star-stroke-width: 1px;
}

/* The focal point sits above-left of center, keeping the numeral field bright
   while a restrained darker anchor falls toward the lower-right points. The
   dark rank ink remains at least 4.66:1 against every declared stop. A 4x
   rendered-pixel probe measured minimum contrast of 10.20:1 (Silver/1 digit),
   10.05:1 (Gold/2 digits), and 6.41:1 (Bronze/3 digits). Solid outlines remain
   at least 5.68:1 across white, paper, and self-row grounds. */
.tier-star--bronze {
  --tier-star-glint: #ffe0b8;
  --tier-star-highlight: #f3b572;
  --tier-star-base: #dc8849;
  --tier-star-anchor: #c16f40;
  --tier-star-outline: #6b321d;
}
.tier-star--silver {
  --tier-star-glint: #f8fbfd;
  --tier-star-highlight: #dce5eb;
  --tier-star-base: #bac7cf;
  --tier-star-anchor: #93a3ad;
  --tier-star-outline: #515e68;
}
.tier-star--gold {
  --tier-star-glint: #fff8ad;
  --tier-star-highlight: #ffe066;
  --tier-star-base: #efc42f;
  --tier-star-anchor: #c99b08;
  --tier-star-outline: #725800;
}
.tier-star--neutral {
  --tier-star-outline: #59636f;
}
.tier-star__stop--glint {
  stop-color: var(--tier-star-glint);
}
.tier-star__stop--highlight {
  stop-color: var(--tier-star-highlight);
}
.tier-star__stop--base {
  stop-color: var(--tier-star-base);
}
.tier-star__stop--anchor {
  stop-color: var(--tier-star-anchor);
}
.tier-star__shape {
  stroke: var(--tier-star-outline);
  stroke-width: var(--tier-star-stroke-width);
  stroke-linecap: round;
  stroke-linejoin: round;
  vector-effect: non-scaling-stroke;
}
.tier-star--neutral .tier-star__shape {
  fill: #eef1f4;
}
.tier-star svg {
  display: block;
  width: 100%;
  height: 100%;
}
.tier-star--rank {
  width: 34px;
  height: 34px;
  --tier-star-stroke-width: 1.125px;
}
.tier-star--name {
  width: 13px;
  height: 13px;
  --tier-star-stroke-width: 0.75px;
}
.tier-star--home {
  width: 15px;
  height: 15px;
  --tier-star-stroke-width: 0.8px;
}
.tier-star--card {
  width: 22px;
  height: 22px;
  --tier-star-stroke-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/tierStar.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;;;+DAK+D;AAC/D;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,qBAAqB;EACrB,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B","sourcesContent":[".tier-star {\n  display: inline-block;\n  flex: 0 0 auto;\n  line-height: 0;\n  --tier-star-stroke-width: 1px;\n}\n\n/* The focal point sits above-left of center, keeping the numeral field bright\n   while a restrained darker anchor falls toward the lower-right points. The\n   dark rank ink remains at least 4.66:1 against every declared stop. A 4x\n   rendered-pixel probe measured minimum contrast of 10.20:1 (Silver/1 digit),\n   10.05:1 (Gold/2 digits), and 6.41:1 (Bronze/3 digits). Solid outlines remain\n   at least 5.68:1 across white, paper, and self-row grounds. */\n.tier-star--bronze {\n  --tier-star-glint: #ffe0b8;\n  --tier-star-highlight: #f3b572;\n  --tier-star-base: #dc8849;\n  --tier-star-anchor: #c16f40;\n  --tier-star-outline: #6b321d;\n}\n.tier-star--silver {\n  --tier-star-glint: #f8fbfd;\n  --tier-star-highlight: #dce5eb;\n  --tier-star-base: #bac7cf;\n  --tier-star-anchor: #93a3ad;\n  --tier-star-outline: #515e68;\n}\n.tier-star--gold {\n  --tier-star-glint: #fff8ad;\n  --tier-star-highlight: #ffe066;\n  --tier-star-base: #efc42f;\n  --tier-star-anchor: #c99b08;\n  --tier-star-outline: #725800;\n}\n.tier-star--neutral {\n  --tier-star-outline: #59636f;\n}\n.tier-star__stop--glint {\n  stop-color: var(--tier-star-glint);\n}\n.tier-star__stop--highlight {\n  stop-color: var(--tier-star-highlight);\n}\n.tier-star__stop--base {\n  stop-color: var(--tier-star-base);\n}\n.tier-star__stop--anchor {\n  stop-color: var(--tier-star-anchor);\n}\n.tier-star__shape {\n  stroke: var(--tier-star-outline);\n  stroke-width: var(--tier-star-stroke-width);\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  vector-effect: non-scaling-stroke;\n}\n.tier-star--neutral .tier-star__shape {\n  fill: #eef1f4;\n}\n.tier-star svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.tier-star--rank {\n  width: 34px;\n  height: 34px;\n  --tier-star-stroke-width: 1.125px;\n}\n.tier-star--name {\n  width: 13px;\n  height: 13px;\n  --tier-star-stroke-width: 0.75px;\n}\n.tier-star--home {\n  width: 15px;\n  height: 15px;\n  --tier-star-stroke-width: 0.8px;\n}\n.tier-star--card {\n  width: 22px;\n  height: 22px;\n  --tier-star-stroke-width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
